var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarToday = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.667 11.34H12v3.3H8.667zm8 5.94H7.333v-7.26h9.334zm0-10.56H16V5.4h-1.333v1.32H9.333V5.4H8v1.32h-.667C6.593 6.72 6 7.314 6 8.04v9.24c0 .35.14.686.39.933.25.248.59.387.943.387h9.334c.353 0 .692-.14.942-.387S18 17.63 18 17.28V8.04c0-.35-.14-.686-.39-.933a1.34 1.34 0 0 0-.943-.387"
})));
export default SvgCalendarToday;